/**
 * The external dependencies.
 */
import {equals, is} from 'ramda';
import moment from 'moment';
/**
 * The internal dependencies.
 */
import {FULL_DATE_FORMAT} from './constants';
import * as R from "ramda";

/**
 * Convert the given value to a string.
 *
 * @param  {mixed}  value
 * @return {String}
 */
export const toString = (value) => {
    return is(String, value) ? value : value.toString();
};

/**
 * Pans given number a given number of zeroes.
 *
 * @param  {String}  value
 * @param  {number}  size
 * @return {String}
 */
export const panNumber = (value, size) => value.length >= size
    ? value
    : `${'0'.repeat(size - value.length)}${value}`;

/**
 * Init empty array.
 *
 * @param  {number}  size
 * @return {String}
 */
export const initArray = (size) => [...Array(size).keys()].map(() => null);

/**
 * Create input values from regular data array
 *
 * @param  {Array}  items
 * @param  {Mixed}  currentValue
 * @param  {Function}  comparison
 * @return {Object}
 */
export const convertToItems = (items, currentValue, comparison = equals) => {
    let val =  items.map(item => ({
        value: item,
        selected: comparison(item, currentValue)
    }));
    return val;
};


export const getFullTimestamp = () => moment().format(FULL_DATE_FORMAT);

export function returnId(string) {
    return '' + R.replace(/{\?.+}/gm, '', R.last(R.split('/', string)));
}

export const getWorkstepLabel = (worksteps, stepindex) => {
    if (R.find(R.propEq('selectionorder', stepindex))(worksteps) !== undefined) {
        let step = R.find(R.propEq('selectionorder', stepindex))(worksteps);
        return step.label !== null ?  step.label : '';
    } else {
        return '';
    }
};

export const getWorkstepName = (worksteps, stepindex) => {
    if (R.find(R.propEq('selectionorder', stepindex))(worksteps) !== undefined) {
        let step = R.find(R.propEq('selectionorder', stepindex))(worksteps);
        return step.name;
    } else {
        return '';
    }
};

export const getStepNameCombi = (worksteps, stepindex) => {
    return (getWorkstepLabel(worksteps, stepindex) !== '' ? getWorkstepLabel(worksteps, stepindex) + '-' : '') + getWorkstepName(worksteps, stepindex);
}

export const isWeekday = date => {
    const day = moment(date).isoWeekday();
    return day !== 7 && day !== 6;
};



// WEBPACK FOOTER //
// ./src/common/utilities.js